import React from 'react';
import {Image} from 'antd';

const BrandSlider = ({brands}) => {
    const doubledBrands = [...brands, ...brands];

    return (<div
            style={{
                width: '100%', overflow: 'hidden', position: 'relative'
            }}
        >
            <div
                style={{
                    display: 'flex', animation: 'slide 30s linear infinite', width: 'max-content'
                }}
            >
                {doubledBrands.map((item, index) => (<div
                        key={index}
                        style={{
                            flexShrink: 0,
                            padding: '0 10px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <Image
                            style={{
                                objectFit: 'cover'
                            }}
                            preview={false}
                            width={100}
                            src={item.logo}
                            alt={item.brand}
                        />
                    </div>))}
            </div>

            <style jsx>{`
                @keyframes slide {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-50%);
                    }
                }

                @media (max-width: 1024px) {
                    div > div > div {
                        padding: 0 8px;
                    }
                }

                @media (max-width: 768px) {
                    div > div > div {
                        padding: 0 6px;
                    }
                }

                @media (max-width: 480px) {
                    div > div > div {
                        padding: 0 4px;
                    }
                }
            `}</style>
        </div>);
};

export default BrandSlider;